import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { UnidataTable } from '~/components';

import {
  deleteMedidor,
  findMedidor,
  recordFiltering,
} from '~/store/modules/medidor/actions';

import Form from './form';

export default function CadastroMedidor() {
  const data = useSelector((state) => state.medidor);

  const listaStatusPesquisa = useMemo(
    () => [
      { label: 'Liberado', value: 'Liberado' },
      { label: 'Bloqueado', value: 'Bloqueado' },
      { label: 'Cancelado', value: 'Cancelado' },
    ],
    []
  );

  const header = useMemo(
    () => [
      {
        id: 'medi_descricao',
        label: 'Descrição',
        filter: { type: 'text' },
      },
      { id: 'medi_multiplicador', label: 'Multi.', align: 'center' },
      { id: 'medi_divisor', label: 'Divi.', align: 'center' },
      { id: 'medi_fator_multiplicacao', label: 'F. Multi.', align: 'center' },
      { id: 'medi_diametro', label: 'Diametro', align: 'center' },
      { id: 'medi_vazao_maxima', label: 'V. Max.', align: 'center' },
      { id: 'medi_vazao_minima', label: 'V. Min.', align: 'center' },
      { id: 'medi_erro_maximo', label: 'Err Max.', align: 'center' },
      { id: 'medi_casas_dec_litro', label: 'Dec. Litro', align: 'center' },
      {
        id: 'medi_casas_dec_encerrante',
        label: 'Dec. Encer.',
        align: 'center',
      },
      {
        id: 'medi_status_str',
        label: 'Status',
        align: 'center',
        formatted: (value) =>
          listaStatusPesquisa.find((option) => option.label === value).value,
        filter: {
          type: 'select',
          options: listaStatusPesquisa,
        },
      },
    ],
    []
  );

  return (
    <UnidataTable
      pdf
      excel
      reportOrder="medi_descricao ASC"
      fixed
      read={recordFiltering}
      remove={deleteMedidor}
      find={findMedidor}
      form={Form}
      redux={data}
      header={header}
      detach="medi_descricao"
      keys="medi_codigo"
      view="VW_MEDIDOR"
      reportTitle="Cadastro de Medidor"
    />
  );
}
